module.exports = __webpack_public_path__ + "assets/img/sabc_about_pic.webp?7c7515f06e0779f80b1d79ce02ce0fbc";